<template>
  <i @click="toggleSelected" class="material-icons">{{getIcon()}}</i>
</template>

<script>
export default {
  props: {
    on: {
      default: "check_box"
    },
    off: {
      default: "check_box_outline_blank"
    },
    selected: {
      default: true
    }
  },
  methods: {
    toggleSelected() {
      // this.selected = !this.selected;
      this.$emit("ontoggle", !this.selected);
    },
    getIcon() {
      return this.selected ? this.on : this.off;
    }
  }
};
</script>

<style lang="scss" scoped>
i.material-icons {
  cursor: pointer;
}
</style>
